import {
  ATTRS_ANALYTICS_FUNNEL_LOCALE,
  ATTRS_ANALYTICS_FUNNEL_NAME,
} from 'core/common/observability/entities';
import { ObservabilitySystem } from 'core/common/observability/interfaces';
import { ErrorMonitoring } from 'core/common/services/errorMonitoring';
import { FunnelSettingsServiceInterface } from 'core/common/services/funnel-settings/interfaces';
import { TikTokService } from '../../interfaces';
import { TikTokServiceWithMonitoring } from './TikTokServiceWithMonitoring';

export class TikTokServiceBuilder {
  constructor(private tikTokService: TikTokService) {}

  addMonitoring(
    observabilitySystem: ObservabilitySystem,
    errorMonitoringService: ErrorMonitoring,
    funnelSettingsService: FunnelSettingsServiceInterface,
  ): this {
    const provideAdditionalObservabilityAttributes = () => {
      return {
        [ATTRS_ANALYTICS_FUNNEL_NAME]: funnelSettingsService.getFunnelName(),
        [ATTRS_ANALYTICS_FUNNEL_LOCALE]: funnelSettingsService.getFunnelLocale(),
      };
    };

    this.tikTokService = new TikTokServiceWithMonitoring(
      this.tikTokService,
      observabilitySystem,
      errorMonitoringService,
      provideAdditionalObservabilityAttributes,
    );

    return this;
  }

  getResult(): TikTokService {
    return this.tikTokService;
  }
}
